import { useEffect } from 'react'

function Login({passportInstance}) {
  useEffect(() => {
    passportInstance.loginCallback();
  }, [passportInstance])
  return (
    <div>Login</div>
  )
}

export default Login